export default __webpack_public_path__ + "static/foundations-carousel-mobile-panel2-490c89a212b619a6ac84d3cf672a63173cf6d494e557c57ad30fb1503498519a.png";